// export const srArtContext = '/srArt/newsInfo'

export default [
  {
    path: `/spectatorService`,
    name: '观众服务',
    meta: {
      title: '观众服务-上饶美术馆',
    },
    component: () => import('../views/spectatorService/service.vue'),
  },
  {
    path: `/spectatorService/appointment`,
    name: '参观预约',
    meta: {
      title: '参观预约-上饶美术馆',
    },
    component: () => import('../views/spectatorService/service.vue'),
  },
  {
    path: `/spectatorService/guide`,
    name: '服务指南',
    meta: {
      title: '服务指南-上饶美术馆',
    },
    component: () => import('../views/spectatorService/guide.vue'),
  },
  {
    path: `/spectatorService/opentime`,
    name: '开馆时间',
    meta: {
      title: '开馆时间-上饶美术馆',
    },
    component: () => import('../views/spectatorService/opentime.vue'),
  },

  {
    path: `/spectatorService/traffic`,
    name: '交通指南',
    meta: {
      title: '交通指南-上饶美术馆',
    },
    component: () => import('../views/spectatorService/traffic.vue'),
  },
  {
    path: `/spectatorService/konw`,
    name: '参观须知',
    meta: {
      title: '参观须知-上饶美术馆',
    },
    component: () => import('../views/spectatorService/guide.vue'),
  },
  {
    path: `/spectatorService/onlineSurvey`,
    name: '在线调查',
    meta: {
      title: '在线调查-上饶美术馆',
    },
    component: () => import('../views/spectatorService/onlineSurvey.vue'),
  },
  {
    path: `/spectatorService/surveyDetails`,
    name: '在线调查详情',
    meta: {
      title: '在线调查详情-上饶美术馆',
    },
    component: () => import('../views/spectatorService/surveyDetails.vue'),
  },
  {
    path: `/spectatorService/electronicMessage`,
    name: '电子留言',
    meta: {
      title: '电子留言-上饶美术馆',
    },
    component: () => import('../views/spectatorService/electronicMessage.vue'),
  }
]

